import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { QuoteForm } from "@/components/site/QuoteForm";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Norwood Scale for Balding | RESTORE® Hair";
const DESCRIPTION =
  "View the Norwood balding scale so our team can give you an accurate estimate. View the images and let us know which one is more like you!";
const CHART = "/img/r/wp-2021-11-norwood-chart-1.webp";

export const Route = createFileRoute("/norwood")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://restorehair.com/norwood/" },
      { property: "og:image", content: absoluteUrl(CHART) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(CHART) },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/norwood/" }],
  }),
  component: NorwoodPage,
});

function NorwoodPage() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <section className="py-10 md:py-14">
          <div className="mx-auto max-w-5xl px-4 lg:px-8">
            <h1 className="text-center text-3xl font-extrabold tracking-tight text-foreground md:text-4xl">
              Norwood Scale Classifications
            </h1>
            <img
              src={CHART}
              alt="Norwood scale chart showing the stages of male pattern hair loss"
              loading="lazy"
              className="mx-auto mt-8 h-auto w-full max-w-4xl"
            />
          </div>
        </section>
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}